import { LoadingTypography } from '@modules/common/components/LoadingTypography';
import { useFetchLabelRecommendations } from '@modules/feed/hooks';
import {
  useFetchMeasuredAsCriteria,
  useGetSelectedGroupByOption,
} from '@modules/quantify/hooks';
import { QuantifyActionType } from '@modules/quantify/store/quantifyActionType';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { VisualisationType } from '@modules/quantify/store/types';
import { Box, CardContent } from '@mui/material';
import { useTheme } from '@mui/system';
import { EqlFieldValueType, ObjectType } from 'generated/graphql';
import { FieldNames } from 'v2/core/entities/fields';
import { OperationType } from 'v2/core/services/queryBuilder/whereClause';
import { getWhereClauseForFieldName } from 'v2/core/services/queryBuilder/whereClauseGenerator';
import { trackQuantifyTemplatesEvent } from './utils';

export function TopRecommendedReasonsTemplate() {
  const theme = useTheme();
  const dispatch = useQuantifyStore(({ dispatch }) => dispatch);
  const {
    isLoading: isReasonFieldLoading,
    selectedGroupByOption: reasonOption,
  } = useGetSelectedGroupByOption(FieldNames.Reason);
  const { criteriaList } = useFetchMeasuredAsCriteria({
    field: reasonOption,
    fetchPolicy: 'cache-first',
  });

  const {
    loading: areRecommendationsLoading,
    recommendations: { entities },
  } = useFetchLabelRecommendations();

  const onClick = () => {
    const whereClause = entities.length
      ? getWhereClauseForFieldName({
          fieldName: FieldNames.Entity,
          values: entities.map(({ id }) => id),
          op: OperationType.AND,
        })
      : null;

    const measuredAsCriteria =
      criteriaList.find((criteria) => {
        return (
          criteria.objectType === ObjectType.Feedback &&
          criteria.valueType === EqlFieldValueType.None
        );
      }) ?? null;

    dispatch({
      type: QuantifyActionType.SET_QUERY,
      payload: {
        groupBy: reasonOption,
        measuredAsCriteria,
        whereClauseConfig: { whereClause },
      },
    });

    dispatch({
      type: QuantifyActionType.SET_METADATA,
      payload: {
        activeVisualisationType: VisualisationType.TREND,
      },
    });

    trackQuantifyTemplatesEvent({
      eventName:
        'Quantify Templates - "Top recommended Reasons for you" clicked',
    });
  };

  const isLoading = isReasonFieldLoading || areRecommendationsLoading;

  return (
    <CardContent
      onClick={onClick}
      sx={{
        pointerEvents: isLoading ? 'none' : 'auto',
      }}
    >
      <LoadingTypography variant="subtitle2" isLoading={isLoading}>
        Top recommended{' '}
        <Box component="span" color={theme.palette.secondary.main}>
          Reasons
        </Box>{' '}
        for you
      </LoadingTypography>
    </CardContent>
  );
}
